<div class="reschedule-row d-flex flex-column flex-lg-row align-items-lg-center justify-content-between p-3">

  <div class="d-flex align-items-center student-cell">
    <coach-student-avatar
      class="me-3" size="sm"
      [name]="request.appointment?.student?.name" [levelKey]="levelKey()"></coach-student-avatar>

    <div class="overflow-hidden">
      <p class="fs-small fw-800 color-gray-950 mb-0 text-truncate">
        {{request.appointment?.student?.name ?? ('agenda.unknown_student'|translate)}}
      </p>
      <p class="fs-xsmall fw-400 color-gray-400 mb-0 text-truncate">{{request.appointment?.title}}</p>
    </div>
  </div>

  <div class="d-flex align-items-center time-cell mt-3 mt-lg-0">
    <div>
      <p class="fs-xsmall fw-800 color-gray-400 mb-0">{{'agenda.reschedule_current'|translate|uppercase}}</p>
      <p class="fs-small fw-500 color-gray-500 mb-0">{{request.appointment?.startsAt|date:'d MMMM EEEE, HH:mm'}}</p>
    </div>

    <i class="bi bi-arrow-right color-gray-300 mx-3"></i>

    <div>
      <p class="fs-xsmall fw-800 color-gray-400 mb-0">{{'agenda.reschedule_requested'|translate|uppercase}}</p>
      <p class="fs-small fw-800 color-gray-950 mb-0">{{request.requestedStartsAt|date:'d MMMM EEEE, HH:mm'}}</p>
    </div>
  </div>

  <div class="d-flex align-items-center mt-3 mt-lg-0">
    <ng-container *ngIf="isPending()">
      <app-gray-button
        color="primary" [fullWidth]="false" padding="px-3 py-2 gap-1" [weight]="800"
        customClass="d-flex align-items-center fs-small border-8 me-2" preIcon="check-fill"
        [disabled]="isBusy" [text]="'buttons.approve'|translate"
        (click)="approveRequested.emit(request)"></app-gray-button>

      <app-gray-button
        color="stroke-gray" [fullWidth]="false" padding="px-3 py-2 gap-1" [weight]="800"
        customClass="d-flex align-items-center fs-small border-8" preIcon="close"
        [disabled]="isBusy" [text]="'buttons.reject'|translate"
        (click)="rejectRequested.emit(request)"></app-gray-button>
    </ng-container>

    <span class="status-chip fs-xsmall fw-800" *ngIf="showStatus && !isPending()"
          [class.approved]="request.status === statuses.Approved"
          [class.rejected]="request.status === statuses.Rejected">
      {{statusKey()|translate}}
    </span>
  </div>

</div>

<!-- Why it was turned down; the student was told the same thing -->
<p class="fs-xsmall fw-400 color-gray-400 px-3 pb-2 mb-0"
   *ngIf="showStatus && request.status === statuses.Rejected && request.note">
  {{'agenda.reschedule_note'|translate}}: {{request.note}}
</p>
